import React, { useState, useEffect } from "react";
import ChatbotWidget from "./ChatbotWidget";
import GarageSetup from "./GarageSetup";

function App() {
  // ✅ Initialize garageData from sessionStorage
  const [garageData, setGarageData] = useState(null);

  // ✅ On first load, clear previous garageData to force Garage Setup
  useEffect(() => {
    sessionStorage.removeItem("garageData"); // clear old data
    sessionStorage.removeItem("garageSetupComplete");
    setGarageData(null);
  }, []);

  // ✅ Handle garage setup completion
  const handleGarageSetupComplete = (data) => {
    const garageInfo = {
      id: data.id || Date.now(),
      ...data
    };
    // Save to sessionStorage
    sessionStorage.setItem("garageData", JSON.stringify(garageInfo));
    sessionStorage.setItem("garageSetupComplete", "true"); // optional flag
    setGarageData(garageInfo); // triggers ChatbotWidget render
  };

  // ✅ Conditional rendering
  return garageData ? (
    <ChatbotWidget garageData={garageData} />
  ) : (
    <GarageSetup onSetupComplete={handleGarageSetupComplete} />
  );
}

export default App;
